export default __webpack_public_path__ + "static/media/IconToPay.20382f3e.svg";